import { Test, TestType } from '../../parser/models/all.js';
import { ClassInstanceField } from '../../parser/models/classInstanceField.js';
import { isClassInstance } from '../../parser/utils/classUtils.js';
import { PreProcessContext } from '../models/preProcessContext.js';
import { getChildGroupName, getClassInstanceChildren } from './preProcessUtils.js';

/**
 * Processor for identifying and creating tests from existing class instances.
 * 
 * @param field - The field containing the class instance.
 * @param index - Field index in the collection.
 * @param context - The pre-processing context.
 * @returns True if the field was processed as a class instance.
 */
export function processClassInstance(field: ClassInstanceField, index: number, context: PreProcessContext): boolean {
  const { name, value } = field;

  if (isClassInstance(value)) {

    context.tests.push(
      new Test(
        field.groupName,
        name,
        value,
        new TestType(TestType.CLASS_INST),
        // test cases
        [],
        // only expression
        ""
      )
    );

    // process existing class instance
    const testProps = getClassInstanceChildren(
      getChildGroupName(field.groupName, name),
      value,
      context.options
    );

    context.tests.push(
      ...testProps
    );

    return true;
  }

  return false;
}
